import Player from '@vimeo/player';
import { gsap } from 'gsap';
import { onVimeoPlay, onVimeoTimeUpdate, onVimeoEnd } from './vimeo-tracking-events';

/**
 * Track all players on page.
 */
window.vimeoVideoPlayers = {} || window.vimeoVideoPlayers;

/**
 * Get an existing Vimeo player by ID.
 *
 * @param {string} id Element ID for the Vimeo Player
 * @returns {{}|null}Vimeo Player object or null
 */
const getPlayerById = (id) => {
  const cleanedId = id.startsWith('vimeo-player-') ? id : `vimeo-player-${id}`;
  if (Object.prototype.hasOwnProperty.call(window.vimeoVideoPlayers, cleanedId)) {
    return window.vimeoVideoPlayers[cleanedId];
  }

  return null;
};

/**
 * Pause all tracked players on page.
 */
const pauseAllPlayers = () => {
  Object.values(window.vimeoVideoPlayers).forEach((player) => player.pause());
};

/**
 * Initialize a properly-formatted Vimeo player given its outer contaienr.
 *
 * @param {Element} playerWrapper The HTML Element containing a valid vimeo initializer.
 */
const initPlayer = (playerWrapper) => {
  const playerPlaceholder = playerWrapper.querySelector('.vimeo-player__placeholder');
  const playerElement = playerWrapper.querySelector('[data-url]');

  if (playerPlaceholder && playerElement) {
    playerPlaceholder.addEventListener('click', (e) => {
      e.preventDefault();
      const player = new Player(playerElement.getAttribute('id'), {
        url: playerElement.getAttribute('data-url'),
        dnt: true,
      });

      gsap.set(playerPlaceholder.querySelector('.vimeo-player__placeholder__play-wrapper'), { display: 'none' });
      gsap.set(playerPlaceholder.querySelector('.vimeo-player__placeholder__loader-wrapper'), { display: 'block' });

      // Loaded.
      player.on('loaded', () => {
        window.vimeoVideoPlayers[playerElement.getAttribute('id')] = player;

        gsap.to(playerPlaceholder, {
          y: '+=100%',
          duration: 0.4,
          onComplete() {
            player.play();
          },
        });
      });

      // Play.
      player.on('play', (data) => onVimeoPlay(player, data));

      // Time Update.
      player.on('timeupdate', (data) => onVimeoTimeUpdate(player, data));

      // End.
      player.on('ended', (data) => onVimeoEnd(player, data));
    });
  }
};

/**
 * Initialize all players given an appropriate class name.
 */
const initAllPlayers = () => {
  const playerWrappers = document.querySelectorAll('.vimeo-player');
  Array.from(playerWrappers).forEach((playerWrapper) => initPlayer(playerWrapper));
};

export {
  initAllPlayers,
  initPlayer,
  getPlayerById,
  pauseAllPlayers,
};
